import axios from 'axios';
 
// Detect base URL
const origin = window.location.origin;
 
// Set API URL dynamically
export const API_URL = origin.includes('uat-eshp')
  ? 'https://uat-eshp-node.diveinprojects.com/api'
  : 'https://eshp-node.diveinprojects.com/api';
 
// Microsoft Azure AD Configuration
export const CLIENT_ID = "4052a213-d406-4764-97ce-6b3a03709ae5";
export const AUTHORITY = "https://login.microsoftonline.com/c3c3e928-85e8-43af-80c2-e705fe9b0cb0";
 
// Dynamic Redirect URI
export const REDIRECT_URI = origin.includes('uat-eshp')
  ? 'https://uat-eshp.diveinprojects.com' : 'https://eshp.diveinprojects.com';
 
// Microsoft Graph API Configuration
export const GRAPH_API_ENDPOINT = "https://graph.microsoft.com/v1.0";
export const GRAPH_SCOPES = [
  "openid",
  "profile",
  "email",
  "User.Read"
]; 